import { createContext, PropsWithChildren, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import useWebSocket from "services/websockets/hooks/useWebSocket";

import { getUserId } from "seneca-common/features/user/state";

import { makeHandleEqSessionXpMessage } from "features/classroom/utils/handleWebsocketMessage";

import { EqSessionDispatchContext } from "./EqSessionDispatchContext";
import useEqSessionReducer, {
  EqSessionState,
  initialEqSessionState
} from "./useEqSessionReducer";

const EqSessionContext = createContext<EqSessionState>(initialEqSessionState);

export function useEqSessionContext() {
  return useContext(EqSessionContext);
}

export function EqSessionContextProvider({ children }: PropsWithChildren<{}>) {
  const reduxDispatch = useDispatch();
  const [state, dispatch] = useEqSessionReducer();
  const location = useLocation();
  const userId = useSelector(getUserId);
  const { sessionId } = state;
  const { assignmentId, source } = location.state || {};

  const webSocketEnabled = !!userId && !!sessionId;

  useWebSocket({
    userId,
    sessionId,
    onMessage: webSocketEnabled
      ? makeHandleEqSessionXpMessage({
          dispatch,
          reduxDispatch,
          sessionId,
          assignmentId,
          source
        })
      : undefined
  });

  return (
    <EqSessionContext.Provider value={state}>
      <EqSessionDispatchContext.Provider value={dispatch}>
        {children}
      </EqSessionDispatchContext.Provider>
    </EqSessionContext.Provider>
  );
}
